import axios from "../../lib/axios";
import { useMutation } from "@tanstack/react-query";

export const useLogoutFromThisDevice = () => {
  return useMutation({
    mutationKey: ["logoutFromThisDevice"],
    mutationFn: async (values) => {
      const deviceId = localStorage.getItem("device_id");

      const response = await axios.post(
        "v2/logout",
        { 
          type: values,
          device_id: deviceId || "",
         },
      );

      return response.data;
    },
  });
};